/**
 * Google AdSense (display web).
 *
 * Defina no .env (sem commitar segredos desnecessários):
 * REACT_APP_ADSENSE_CLIENT_ID=ca-pub-XXXXXXXX
 * REACT_APP_ADSENSE_SLOT_ID=1234567890   (ID numérico da unidade no painel)
 *
 * Em localhost o AdSense costuma ficar vazio até o domínio estar aprovado.
 */

export const ADSENSE_PUBLISHER_CLIENT =
  process.env.REACT_APP_ADSENSE_CLIENT_ID || "ca-pub-9039263585869439";

/** ID numérico do bloco de anúncio criado no AdSense (não use slugs como "footer-ad"). */
export const ADSENSE_DEFAULT_SLOT_ID =
  process.env.REACT_APP_ADSENSE_SLOT_ID || "9994834381";
